import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { LocalStorageService } from "@shared-services/local-storage.service";
import { LocalStorageConst } from "../constants/storage.const";
import { TokenManager } from "./token.manager";

@Injectable({ providedIn: 'root' })
export class RedeemManager
{
  public isUserLoggedIn = false;
  public userId: string | null = null;

  private _domain: string | null = null;
  private _token: string | null = null;
  private _status: string | null = null;
  private _initiativeId: string | null = null;

  constructor(
    public tokenManager: TokenManager,
    public localStorageService: LocalStorageService,
    public cookieService: CookieService
  ) { }

  // ====== TOKEN ======
  public get token(): string | null
  {
    const res = this.localStorageService.getItem(LocalStorageConst.HEMToken);
    this._token = res ?? null;
    return this._token;
  }

  public set token(value: string | null)
  {
    this.localStorageService.removeItem(LocalStorageConst.HEMToken);
    if (value && value.trim() !== "")
    {
      this.localStorageService.setItem(LocalStorageConst.HEMToken, value);
      this._token = value;
    }
    else
    {
      this._token = null;
    }
  }

  public removeToken(): void
  {
    this.localStorageService.removeItem(LocalStorageConst.HEMToken);
    this._token = null;
  }

  // ====== DOMAIN ======
  public get domain(): string | null
  {
    const res = this.localStorageService.getItem(LocalStorageConst.HEMDomain);
    this._domain = res ?? null;
    return this._domain;
  }

  public set domain(value: string | null)
  {
    this.localStorageService.removeItem(LocalStorageConst.HEMDomain);
    if (value && value.trim() !== "")
    {
      this.localStorageService.setItem(LocalStorageConst.HEMDomain, value);
      this._domain = value;
    }
    else
    {
      this._domain = null;
    }
  }

  public removeDomain(): void
  {
    this.localStorageService.removeItem(LocalStorageConst.HEMDomain);
    this._domain = null;
  }

  // ====== STATUS ======
  public get status(): string | null
  {
    const res = this.localStorageService.getItem(LocalStorageConst.HEMStatus);
    this._status = res ?? null;
    return this._status;
  }

  public set status(value: string | null)
  {
    this.localStorageService.removeItem(LocalStorageConst.HEMStatus);
    if (value && value.trim() !== "")
    {
      this.localStorageService.setItem(LocalStorageConst.HEMStatus, value);
      this._status = value;
    }
    else
    {
      this._status = null;
    }
  }

  public removeStatus(): void
  {
    this.localStorageService.removeItem(LocalStorageConst.HEMStatus);
    this._status = null;
  }

  // ====== INICIATIVA ID ======
  public get initiativeId(): string | null
  {
    const res = this.localStorageService.getItem(LocalStorageConst.InitiativeId);
    this._initiativeId = res ?? null;
    return this._initiativeId;
  }

  public set initiativeId(value: string | null)
  {
    this.localStorageService.removeItem(LocalStorageConst.InitiativeId);
    if (value && value.trim() !== "")
    {
      this.localStorageService.setItem(LocalStorageConst.InitiativeId, value);
      this._initiativeId = value;
    }
    else
    {
      this._initiativeId = null;
    }
  }

  public removeInitiativeId(): void
  {
    this.localStorageService.removeItem(LocalStorageConst.InitiativeId);
    this._initiativeId = null;
  }


  public checkLogin(): void
  {
    const user = this.tokenManager.getUser();

    if (user)
    {
      this.isUserLoggedIn = true;
      this.userId = user.id;
      return;
    }

    this.isUserLoggedIn = false;
  }
}
